module.exports = __webpack_public_path__ + "static/media/status-badge-custom.29a7ad25.svg";